import { watch } from "vue";
import { Prop, Ref, Vue } from "vue-property-decorator";
import "./app-block-ui.scss";

export class AppBlockUIComponent extends Vue {
    @Prop({ required: false })
    blocked!: boolean;

    @Ref()
    pBlockUI?: {
        readonly mask?: HTMLElement;
    };

    mounted() {
        watch(
            () => ({
                blocked: this.blocked,
            }),
            ({ blocked }) => {
                if (!blocked) {
                    this.$nextTick(() => {
                        if (this.pBlockUI?.mask?.classList.contains("p-blockui-leave")) {
                            this.pBlockUI.mask.remove();
                        }
                    });
                }
            },
            { immediate: true },
        );
    }
}
